module.exports = "<span class=\"popover-trigger\" v-el:trigger>\n\t<slot></slot>\n</span> \n<div class=\"popover {{popoverAlignment}}\" v-el:popover>\n  <div class=\"popover-arrow\"></div>\n  <h3 class=\"popover-title\" v-if=\"title\">{{title}}</h3>\n  <div class=\"popover-content\">\n    <span v-html=\"text\" v-if=\"text\"></span>\n    <slot name=\"content\" v-if=\"!text\"></slot>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/popover/popover.html
// module id = 69
// module chunks = 0